/**
 * Drop bars on a different price scale than the listing (e.g. futures OHLC stored under ETC tickers).
 * Mirrors datacollect investing.models.stock_daily_price.sanitize_price_bars.
 */
const BAND_RATIO = 6;

export function sanitizeListingPriceBars(bars, anchorClose) {
  if (!bars?.length) return [];

  let anchor = anchorClose;
  if (anchor == null || Number.isNaN(anchor) || anchor <= 0) {
    for (let i = bars.length - 1; i >= 0; i -= 1) {
      const c = bars[i]?.close;
      if (c != null && !Number.isNaN(c) && c > 0) {
        anchor = Number(c);
        break;
      }
    }
  }
  if (anchor == null || anchor <= 0) return bars;

  const lo = anchor / BAND_RATIO;
  const hi = anchor * BAND_RATIO;

  const filtered = bars.filter((bar) => {
    const close = bar?.close;
    return close != null && close >= lo && close <= hi;
  });

  if (filtered.length >= 2) return filtered;

  const tail = bars.slice(-Math.min(bars.length, 400));
  const tailFiltered = tail.filter((bar) => {
    const close = bar?.close;
    return close != null && close >= lo && close <= hi;
  });
  return tailFiltered.length ? tailFiltered : filtered;
}
